import './App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getLaboratori } from './api/api.private.service';
import { getMediaLink } from './api/utils';

function HomePage() {
  const [labs, setLabs] = useState([]);

  useEffect(() => {
    const fetchLaboratori = async () => {
      try {
        const data = await getLaboratori();
        setLabs(data.data);
      } catch (error) {
        console.error('Error fetching laboratori:', error);
      }
    };

    fetchLaboratori();
  }, []);

  return (
    <div
      className="min-h-screen">
      <Navbar />
      <section
          className="text-center py-20"
          style={{
            backgroundImage: 'url("/header.png")',
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
          }}
        >
          <h2 className="text-4xl font-extrabold text-gray-800 font-space bg-white bg-opacity-75 inline-block px-4 py-2">
            [ Laboratori remoti ]
          </h2>
        </section>
      <section className="py-6 px-6">
        {labs &&
          labs.map((lab) => (
            <div
              key={lab.id}
              className="max-w-4xl mx-auto bg-white p-6 shadow-md mb-6 text-center"
            >
              <div className="flex flex-col md:flex-row">
                <img
                  src={getMediaLink(lab.immagine?.url)}
                  className="mx-auto"
                  width={'300px'}
                  alt={lab.nome}
                />
                <div className="text-left ml-4">
                  <h2 className="text-2xl font-bold text-gray-800 mt-4">{lab.nome}</h2>
                  <p className="text-gray-600 mt-2">{lab.descrizione}</p>
                </div>
              </div>
              
              
              <h3 className="text-2xl font-bold text-gray-800 mt-12 font-space">[ Esperimenti ]</h3>
              <div className="mt-4">
                {lab.esperimentis &&
                  lab.esperimentis.map((esp, index) => (
                    <div
                      key={index}
                      className="flex flex-col md:flex-row items-center p-4 shadow-md mb-4"
                    >
                      <img
                        src={getMediaLink(esp.immagine?.url)}
                        className="w-32 object-cover mr-4"
                        alt={esp.titolo}
                      />
                      <div className="text-left">
                        <h3 className="text-xl font-semibold text-gray-800 font-space">
                          {esp.titolo}
                        </h3>
                        <p className="text-gray-600 mt-2">{esp.descrizione}</p>
                        <Link
                          to={`/booking/${lab.id}?esp=${esp.id}`}
                          className="mt-4 inline-block bg-[white] uppercase font-semibold text-sm border-black border-2 hover:bg-black hover:text-white text-black px-4 py-2 shadow-md hover:bg-[#e06615]"
                        >
                          <i className="fas fa-calendar mr-2"></i> Prenota
                        </Link>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
      </section>
      <Footer />
    </div>
  );
}

export default HomePage;